import { getData } from '../../../API/GlobalApi';

// Finance Dashboard API service
export const financeApi = {
    // Get dashboard overview data
    getDashboardOverview: async (startDate, endDate) => {
        const params = new URLSearchParams();
        if (startDate) params.append('start_date', startDate);
        if (endDate) params.append('end_date', endDate);
        // Add cache-busting parameter
        params.append('_t', Date.now().toString());
        
        const query = params.toString() ? `?${params.toString()}` : '';
        return await getData(`finance/dashboard/${query}`);
    },

    // Get employee performance data
    getEmployeePerformance: async (filters = {}) => {
        const params = new URLSearchParams();
        
        // Date filters
        if (filters.startDate) params.append('start_date', filters.startDate);
        if (filters.endDate) params.append('end_date', filters.endDate);
        
        // Pagination and sorting
        if (filters.topN) params.append('top_n', filters.topN.toString());
        if (filters.page) params.append('page', filters.page.toString());
        if (filters.pageSize) params.append('page_size', filters.pageSize.toString());
        if (filters.ordering) params.append('ordering', filters.ordering);
        
        // Add cache-busting parameter
        params.append('_t', Date.now().toString());
        
        const query = params.toString() ? `?${params.toString()}` : '';
        return await getData(`finance/dashboard/employee-performance/${query}`);
    },

    // Get instruments in hand data
    getInstrumentsInHand: async (includeEmpty = false, employeeId = null) => {
        const params = new URLSearchParams();
        if (includeEmpty) params.append('include_empty', 'true');
        if (employeeId) params.append('employee_id', employeeId.toString());
        // Add cache-busting parameter
        params.append('_t', Date.now().toString());
        
        const query = params.toString() ? `?${params.toString()}` : '';
        return await getData(`finance/dashboard/instruments-in-hand/${query}`);
    }
};

// WebSocket URL helper
export const getWebSocketUrl = (endpoint) => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    if (baseUrl) {
        // Convert HTTP/HTTPS URL to WebSocket URL
        let wsBase = baseUrl.replace(/^https?:\/\//, 'ws://').replace(/\/$/, '');
        
        // Handle localhost specifically for Docker development
        if (wsBase.includes('localhost') || wsBase.includes('127.0.0.1')) {
            wsBase = 'ws://localhost:9000';
        }
        
        return `${wsBase}${endpoint}`;
    }
    return `ws://localhost:9000${endpoint}`;
};

// WebSocket endpoints
export const webSocketEndpoints = {
    dashboard: '/ws/finance/dashboard/',
    notifications: '/ws/finance/notifications/'
};
